import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { HsButtonModule, HsSearchBarModule } from '@hsetu/ngui-components';
import {
  HsContactDetailsConfig,
  HsContactBookComponent,
  HsContactData,
} from '@hsetu/ngui-views';
import { HsLayerDirective } from '@hsetu/ngui-resources';
import { DialogRef } from '@angular/cdk/dialog';
import { ContactDataSource } from '@modules/contact/models/contact-datasource.model';
import {
  CANCEL_LABEL,
  OK_LABEL,
} from '@modules/contact/i18n/label-text-constants';

@Component({
  selector: 'kfm-contact-book-dialog',
  standalone: true,
  imports: [
    CommonModule,
    HsContactBookComponent,
    HsSearchBarModule,
    HsLayerDirective,
    HsButtonModule,
  ],
  templateUrl: './kfm-contact-book-dialog.component.html',
})
export class KfmContactBookDialogComponent {
  protected readonly okLabel = OK_LABEL;
  protected readonly cancelLabel = CANCEL_LABEL;

  protected readonly dialogRef =
    inject<DialogRef<HsContactData | null>>(DialogRef);

  protected contactDataSource: ContactDataSource;
  protected config: HsContactDetailsConfig;
  protected selectedContact: HsContactData | null = null;

  constructor() {
    this.config = new HsContactDetailsConfig();
    this.contactDataSource = new ContactDataSource();
  }

  protected onSearchValueChanged(searchValue: string): void {
    this.contactDataSource.dataSource.setSearchTerm(searchValue);
    this.contactDataSource.dataSource.load();
  }

  protected onContactSelected(contact: HsContactData): void {
    this.selectedContact = contact;
  }
}
